import { render } from "./RejectionModal.vue?vue&type=template&id=762f0a4a"
import script from "./RejectionModal.vue?vue&type=script&lang=js"
export * from "./RejectionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__